export default __webpack_public_path__ + "images/pictograms/large-print.svg?a7f164cbe9d5c051c83db64b36e827727ed387e5c07d31b432b47f2b11b525cf";